import { Component, OnDestroy } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { Meta, Title } from '@angular/platform-browser'
import { SEOService } from '@flowaccount/landing'
import { Subscription } from 'rxjs'
@Component({
  selector: 'flowaccount-business-registration-ads',
  templateUrl: './business-registration-ads.component.html',
})
export class BusinessRegistrationAdsComponent implements OnDestroy {
  public customInviteSection = {
    headingDesktopTH: 'ขยายกิจการอย่างอุ่นใจ เริ่มต้นสเต็ปใหม่ <br> พร้อมกับผู้เชี่ยวชาญจาก FlowAccount',
    headingDesktopEN: 'ขยายกิจการอย่างอุ่นใจ เริ่มต้นสเต็ปใหม่ <br> พร้อมกับผู้เชี่ยวชาญจาก FlowAccount',
    headingMobileTH: 'ขยายกิจการอย่างอุ่นใจ เริ่มต้นสเต็ปใหม่ <br> พร้อมกับผู้เชี่ยวชาญจาก FlowAccount',
    headingMobileEN: 'ขยายกิจการอย่างอุ่นใจ เริ่มต้นสเต็ปใหม่ <br> พร้อมกับผู้เชี่ยวชาญจาก FlowAccount',
    buttonNameTH: 'ลงทะเบียนเลย',
    buttonNameEN: 'ลงทะเบียนเลย',
  }
  public goodPoint = [
    {
      title: 'BUSINESS_REGISTRATION_ADS.GOOD_POINT.TITLE',
      detail: 'BUSINESS_REGISTRATION_ADS.GOOD_POINT.DETAIL',
    },
  ]
  public goodPointList = [
    {
      title: 'BUSINESS_REGISTRATION_ADS.GOOD_POINT.1.TITLE',
      description: 'BUSINESS_REGISTRATION_ADS.GOOD_POINT.1.DETAIL',
      imgWebp: 'https://flowaccountcdn.com/new_landing/image/functions/business/business_swiper_1_v2.webp',
      img: 'https://flowaccountcdn.com/new_landing/image/functions/business/business_swiper_1_v3.png',
      alt: 'BUSINESS_REGISTRATION_ADS.GOOD_POINT.1.ALT',
    },
    {
      title: 'BUSINESS_REGISTRATION_ADS.GOOD_POINT.2.TITLE',
      description: 'BUSINESS_REGISTRATION_ADS.GOOD_POINT.2.DETAIL',
      imgWebp: 'https://flowaccountcdn.com/new_landing/image/functions/business/business_swiper_5.png',
      img: 'https://flowaccountcdn.com/new_landing/image/functions/business/business_swiper_5.png',
      alt: 'BUSINESS_REGISTRATION_ADS.GOOD_POINT.2.ALT',
    },
    {
      title: 'BUSINESS_REGISTRATION_ADS.GOOD_POINT.3.TITLE',
      description: 'BUSINESS_REGISTRATION_ADS.GOOD_POINT.3.DETAIL',
      imgWebp: 'https://flowaccountcdn.com/new_landing/image/functions/business/business_swiper_2_v2.webp',
      img: 'https://flowaccountcdn.com/new_landing/image/functions/business/business_swiper_2_v2.png',
      readMore: 'https://flowaccount.com/pricing',
      alt: 'BUSINESS_REGISTRATION_ADS.GOOD_POINT.3.ALT',
    },
    {
      title: 'BUSINESS_REGISTRATION_ADS.GOOD_POINT.4.TITLE',
      description: 'BUSINESS_REGISTRATION_ADS.GOOD_POINT.4.DETAIL',
      imgWebp: 'https://flowaccountcdn.com/new_landing/image/functions/business/business_swiper_3_v2.webp',
      img: 'https://flowaccountcdn.com/new_landing/image/functions/business/business_swiper_3_v2.png',
      alt: 'BUSINESS_REGISTRATION_ADS.GOOD_POINT.4.ALT',
    },
    {
      title: 'BUSINESS_REGISTRATION_ADS.GOOD_POINT.5.TITLE',
      description: 'BUSINESS_REGISTRATION_ADS.GOOD_POINT.5.DETAIL',
      imgWebp: 'https://flowaccountcdn.com/new_landing/image/functions/business/business_swiper_4_v1.webp',
      img: 'https://flowaccountcdn.com/new_landing/image/functions/business/business_swiper_4_v1.png',
      alt: 'BUSINESS_REGISTRATION_ADS.GOOD_POINT.5.ALT',
    },
  ]
  public reviewSectionTextList = {
    title: 'BUSINESS_REGISTRATION_ADS.REVIEW_SECTION.HEADING',
    detail: 'BUSINESS_REGISTRATION_ADS.REVIEW_SECTION.DETAIL',
    button: 'BUSINESS_REGISTRATION_ADS.REVIEW_SECTION.BTN',
  }
  protected seoLangSubscription: Subscription

  constructor(
    public translate: TranslateService,
    private seoService: SEOService,
    private titleService: Title,
    private meta: Meta,
  ) {
    this.seoLangSubscription = translate.onLangChange.subscribe(() => {
      const setContent = 'noindex'
      this.meta.updateTag({ name: 'robots', content: setContent })
      this.setMeta()
    })
  }
  ngOnDestroy() {
    this.seoLangSubscription?.unsubscribe()
  }
  private setMeta() {
    const title = this.translate.instant('BUSINESS_REGISTRATION_ADS.META_TITLE')
    const description = this.translate.instant('BUSINESS_REGISTRATION_ADS.META_DESCRIPTION')
    const imageUrl = 'https://flowaccountcdn.com/new_landing/image/functions/business/business_header_v4.png'
    const canonicalUrl = 'https://flowaccount.com/business-registration/2'

    this.titleService.setTitle(title)
    this.seoService.createMetaTag(title, description)
    this.seoService.createOg(imageUrl, title, description)
    this.seoService.setCanonicalUrl(canonicalUrl)
  }
}
